import React, { useState, useEffect } from 'react';
import { db, storage } from '../firebaseConfig';
import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc
} from 'firebase/firestore';
import {
  ref,
  uploadBytes,
  getDownloadURL
} from 'firebase/storage';

const AdminServiceManagement = ({ user, setError }) => {
  const [services, setServices] = useState([]);
  const [currentService, setCurrentService] = useState({ name: '', description: '', price: '', imageUrl: '' });
  const [editingServiceId, setEditingServiceId] = useState(null);
  const [imageFile, setImageFile] = useState(null);

  const servicesCollectionRef = collection(db, 'services');

  useEffect(() => {
    if (user) {
      const fetchData = async () => {
        try {
          const servicesSnapshot = await getDocs(servicesCollectionRef);
          setServices(servicesSnapshot.docs.map(doc => ({ ...doc.data(), id: doc.id })));
        } catch (err) {
          setError('Error al cargar los datos de servicios. Por favor, revise las reglas de seguridad de Firestore.');
          console.error(err);
        }
      };
      fetchData();
    }
  }, [user, setError]);

  const handleServiceSubmit = async (e) => {
    e.preventDefault();

    let imageUrl = currentService.imageUrl; // Keep existing image if not changed

    if (imageFile) {
      const storageRef = ref(storage, `services-images/${imageFile.name}`);
      try {
        await uploadBytes(storageRef, imageFile);
        imageUrl = await getDownloadURL(storageRef);
      } catch (error) {
        setError('Error al subir la imagen.');
        console.error('Error uploading image: ', error);
        return; // Stop if image upload fails
      }
    }

    const serviceData = { ...currentService, imageUrl };

    if (editingServiceId) {
      await updateService(serviceData);
    } else {
      await addService(serviceData);
    }
  };

  const addService = async (serviceData) => {
    try {
      const docRef = await addDoc(servicesCollectionRef, serviceData);
      setServices([...services, { id: docRef.id, ...serviceData }]);
      setCurrentService({ name: '', description: '', price: '', imageUrl: '' });
      setImageFile(null);
    } catch (error) {
      setError('Error al agregar el servicio.');
      console.error('Error adding service: ', error);
    }
  };

  const updateService = async (serviceData) => {
    try {
      const serviceDoc = doc(db, 'services', editingServiceId);
      await updateDoc(serviceDoc, serviceData);

      setServices(services.map(srv => srv.id === editingServiceId ? { id: editingServiceId, ...serviceData } : srv));
      setEditingServiceId(null);
      setCurrentService({ name: '', description: '', price: '', imageUrl: '' });
      setImageFile(null);
    } catch (error) {
      setError('Error al actualizar el servicio.');
      console.error('Error updating service: ', error);
    }
  };

  const deleteService = async (id) => {
    try {
      await deleteDoc(doc(db, 'services', id));
      setServices(services.filter(srv => srv.id !== id));
    } catch (error) {
      setError('Error al eliminar el servicio.');
      console.error('Error deleting service: ', error);
    }
  };

  return (
    <section>
      <h2>Servicios</h2>
      <form onSubmit={handleServiceSubmit} style={{ marginBottom: '20px' }}>
        <input
          type="text"
          placeholder="Nombre del servicio"
          value={currentService.name}
          onChange={(e) => setCurrentService({ ...currentService, name: e.target.value })}
          style={{ marginRight: '10px', padding: '8px', width: '200px' }}
        />
        <textarea
          placeholder="Descripción del servicio"
          value={currentService.description}
          onChange={(e) => setCurrentService({ ...currentService, description: e.target.value })}
          style={{ marginRight: '10px', padding: '8px', width: '300px', height: '100px' }}
        />
        <input
          type="file"
          onChange={(e) => setImageFile(e.target.files[0])}
          style={{ marginRight: '10px', padding: '8px', width: '300px' }}
        />
        <input
          type="number"
          placeholder="Precio"
          value={currentService.price}
          onChange={(e) => setCurrentService({ ...currentService, price: e.target.value })}
          style={{ marginRight: '10px', padding: '8px', width: '100px' }}
        />
        <button type="submit" style={{ padding: '8px 12px' }}>{editingServiceId ? 'Actualizar Servicio' : 'Agregar Servicio'}</button>
      </form>

      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Nombre</th>
            <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Descripción</th>
            <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Precio</th>
            <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {services.map(srv => (
            <tr key={srv.id}>
              <td style={{ border: '1px solid #ddd', padding: '8px' }}>{srv.name}</td>
              <td style={{ border: '1px solid #ddd', padding: '8px' }}>{srv.description}</td>
              <td style={{ border: '1px solid #ddd', padding: '8px' }}>${srv.price}</td>
              <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                <button onClick={() => { setEditingServiceId(srv.id); setCurrentService({ name: srv.name, description: srv.description, price: srv.price, imageUrl: srv.imageUrl || '' }); setImageFile(null); }} style={{ marginRight: '5px' }}>Editar</button>
                <button onClick={() => deleteService(srv.id)}>Eliminar</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
};

export default AdminServiceManagement;
